export default __webpack_public_path__ + "static/media/img_10.97088f75.JPG";